import React from 'react'
import { CiFacebook } from "react-icons/ci";
import { IoLogoInstagram } from "react-icons/io";
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import Backdrop from '@mui/material/Backdrop';

import ShareIcon from '@mui/icons-material/Share';
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const Footer = () => {
     // speedDial
    const handleShare = () => {
      const shareData = {
        title: 'talabulilm.in',
        text: 'Talabulilm | Namaz Time Table for Cities Across India',
        url: 'https://talabulilm.in',
      };
    
      if (navigator.share) {
        navigator.share(shareData).catch((error) => console.log('Sharing failed:', error));
      } else {
        // Fallback for unsupported browsers
        const whatsappMessage = `${shareData.text} ${shareData.url}`;
        const whatsappShareUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(whatsappMessage)}`;
        window.open(whatsappShareUrl, '_blank');
      }
    };
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const handleInstagram = () => {
      window.open("https://www.instagram.com/talabulilm.in/", "_blank");
    };
    
    const handleWhatsAppChannel = () => {
      window.open("https://whatsapp.com/channel/0029Vaz5bRCIXnlvQglJ572j", "_blank");
    };

    const actions = [
      { icon: <WhatsAppIcon />, name: 'WhatsApp Channel', onClick: handleWhatsAppChannel },
      { icon: <InstagramIcon />, name: 'Instagram', onClick: handleInstagram },
      { icon: <ShareIcon />, name: 'Share', onClick: handleShare },
    ];

  return (
    <footer className="Footer">
    <div className="Footer_Item--left">
       <span>Follow Us : </span>
       <div className="Footer__social-icon">
          <a href="https://www.facebook.com/talabulilm.in/" rel='noreferrer' target="_blank" title="facebook" aria-label="facebook">
          <CiFacebook size={30} />
          </a>
          <a href="https://www.instagram.com/talabulilm.in/" rel='noreferrer' target="_blank" title="instagram" aria-label="instagram">
          <IoLogoInstagram size={30} />
          </a>
       </div>
    </div>
    <div className="Footer_Item--right">
    <p>| talabulilm.in</p>
    </div>
    <Backdrop open={open} />
      <SpeedDial
        ariaLabel="SpeedDial "
        sx={{ position: 'fixed', bottom: 16, right: 12 }}
        icon={<SpeedDialIcon />}
        onClose={handleClose}
        onOpen={handleOpen}
        open={open}
      >
        {actions.map((action) => (
          <SpeedDialAction
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.name}
            tooltipOpen
            onClick={action.onClick || (() => {})}
          />
        ))}
      </SpeedDial>
  
      {/* <SpeedDial
        ariaLabel="SpeedDial tooltip example"
        sx={{ position: 'absolute', bottom: 16, right: 16 }}
        icon={<SpeedDialIcon />}
        onClose={handleClose}
        onOpen={handleOpen}
        open={open}
      >
        {actions.map((action) => (
          <SpeedDialAction
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.name}
            tooltipOpen
            onClick={handleClose}
          />
        ))}
      </SpeedDial> */}
 </footer>
  )
}

export default Footer